import parseUA from 'ua-parser-js';

const ua = new parseUA(navigator.userAgent);
const browser = ua.getBrowser().name;
const OS = ua.getOS().name;

// OS may not be Android or iOS
const badOS = ['ios', 'android'].includes(OS.toLowerCase());

// Browser must be Chrome, Firefox, or Edge
let goodBrowser = ['chrome', 'edge'].includes(browser.toLowerCase());

// Detect Chrome version
// https://stackoverflow.com/a/4900484
function getChromeVersion() {     
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : false;
}

const cv = getChromeVersion();
if (cv && cv < 81) {
    goodBrowser = false;
}

function validateBrowser() {
  return !badOS && goodBrowser;
}

export default validateBrowser;
